import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_COMPANY_ACA_DEDUCTION_OPTION_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
